import React, { useMemo } from 'react';
import { formatInTimeZone } from 'date-fns-tz';
import { Typography } from '@mui/material';

import GraphIcon from '../GraphIcon';

import styles from './OutOfRange.module.scss';

interface Props {
  bucketStartTimeInMs: number;
  onClick?: () => void;
  timezone: string;
}

const OutOfRange: React.FC<Props> = ({ bucketStartTimeInMs, onClick, timezone }) => {
  const dateNow = useMemo(() => Date.now(), []);
  const isToday = useMemo(() => {
    const today = formatInTimeZone(dateNow, timezone, 'EEE, M/d');
    return formatInTimeZone(bucketStartTimeInMs, timezone, 'EEE, M/d') === today;
  }, [bucketStartTimeInMs, dateNow, timezone]);

  return (
    <button
      className={styles.outOfRange}
      data-testid="out-of-range-button"
      disabled={!isToday || !onClick}
      onClick={onClick}
      type="button"
    >
      <Typography
        className={styles.outOfRangeEarly}
        component="p"
        data-testid="out-of-range-text"
        variant="caption1"
      >
        No tracked waves.
      </Typography>
      {isToday && onClick && (
        <Typography
          className={styles.outOfRangeCta}
          component="p"
          data-testid="out-of-range-cta"
          variant="caption1"
        >
          View last tracked waves
        </Typography>
      )}
      <GraphIcon className={styles.graphIcon} />
    </button>
  );
};

export default OutOfRange;
